module.exports = __webpack_public_path__ + "img/dick2-cover-1.bba850e3.jpg";